import { File, initialFile } from './file/file-state.model';
import { Common, initialCommon } from './common/common-state.model';
import { Auth, initialAuth } from './auth/auth-state.model';
import { CustomerState, initialCustomerState } from './customer/customer-state.model';
import { VehicleState, initialVehicleState } from './vehicle-store/vehicle-state.model';
import { SelectedVehicleState, initialSelectedVehicleState } from './selected-vehicle-store/selected-vehicle-state.model';
import { initialStepState, StepState } from './steps-store/step-state.model';
import { AdminState, initialAdminState } from './admin-store/admin-state.model';
import { UserRoleState, initialUserRoleState } from './user-role/user-role-state.model';
import { UpdateState, initialUpdateState } from './update-customer/update-state.model';
import { initialApiResponseState, ApiResponseState } from './api-response/api-response-state.model';

export interface AppState {
  file: File;
  auth: Auth;
  common: Common;
  customer: CustomerState;
  vehicle: VehicleState;
  selectedVehicle: SelectedVehicleState;
  api: ApiResponseState;
  step: StepState;
  admin: AdminState;
  update: UpdateState;
  userRole: UserRoleState;
}
export const INITIAL_STATE = {
  file: initialFile,
  auth: initialAuth,
  common: initialCommon,
  customer: initialCustomerState,
  vehicle: initialVehicleState,
  selectedVehicle: initialSelectedVehicleState,
  api: initialApiResponseState,
  step: initialStepState,
  admin: initialAdminState,
  update: initialUpdateState,
  userRole: initialUserRoleState,
};
